import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule, TRANSLATIONS, TRANSLATIONS_FORMAT } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr);
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesModule } from './pages/pages.module';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { RouteHandlerModule } from './core/route-handler/route-handler.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material';
import { MatPaginatorIntl } from '@angular/material';

import { I18n } from '@ngx-translate/i18n-polyfill';

import { environment } from '../environments/environment';

import { AuthService } from './core/auth/auth.service';
import { AuthGuard } from './core/auth/auth.guard';
import { PaginatorIntl } from './core/utils/paginator-intl';
import { CanDeactivateGuard } from './core/can-deactivate/can-deactivate.guard';
import { InterceptorService } from './services/interceptor.service';
import { AddressService } from './core/services/address.service';

declare const require;

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'elastic-ui' }),
    BrowserAnimationsModule,
    HttpClientModule,
    StoreModule.forRoot(reducers),
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 50 }) : [],
    EffectsModule.forRoot([]),
    AppRoutingModule,
    CoreModule,
    PagesModule,
    RouteHandlerModule,
    MatSnackBarModule,
  ],
  providers: [
    AuthService,
    AuthGuard,
    AddressService,
    CanDeactivateGuard,
    { provide: MatPaginatorIntl, useClass: PaginatorIntl },
    { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
    { provide: TRANSLATIONS, useValue: require('raw-loader!../locale/messages.fr.xlf') },
    { provide: LOCALE_ID, useValue: 'fr' },
    I18n,
    InterceptorService,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/app.module.ts